import tippy from 'tippy.js';
import { BaseAjaxService } from './shared/BaseAjaxService.js';
import { PriceCalculator } from './shared/PriceCalculator.js';
import { NotificationManager } from './shared/NotificationManager.js';

export default function objectPlanScripts() {
  const isPresent = document.querySelector('.object-plan-select');
  if (!isPresent) {
    return;
  }

  const elements = {
    buttons: document.querySelectorAll('.object-plan-select'),
    confirmButton: document.querySelector('[data-confirm-plan]'),
    frontPlanButton: document.querySelector('[data-front-select-plan]'),
    changePlanButton: document.querySelector('[data-change-plan]'),
    imgElements: document.querySelectorAll('.js-panzoom-el'),
    body: document.body
  };

  const ajaxService = new BaseAjaxService();
  const priceCalculator = new PriceCalculator();
  const notificationManager = new NotificationManager();

  let selectedPlan = ajax_object.selectedPlan;
  const planConfirmed = ajax_object.planConfirmed;
  const userDisabled = ajax_object.userDisabled;

  init();

  function init() {
    setupUserDisabledTooltips();
    setupEventListeners();
    initializeSelectedPlan();
    setConfirmedState();
  }

  function setupUserDisabledTooltips() {
    if (userDisabled) {
      elements.buttons.forEach(button => {
        tippy(button, {
          content: 'Muudatuste tegemine pole lubatud',
          trigger: 'mouseenter focus',
          theme: 'light'
        });
      });
    }
  }

  function setupEventListeners() {
    // Plan selection buttons
    elements.buttons.forEach(button => {
      button.addEventListener('click', () => handlePlanSelection(button));
    });

    // Confirm button
    if (elements.confirmButton) {
      elements.confirmButton.addEventListener('click', confirmPlan);
    }

    // Change plan button  
    if (elements.changePlanButton) {
      elements.changePlanButton.addEventListener('click', resetPlanConfirmation);
    }
  }

  function initializeSelectedPlan() {
    if (!selectedPlan && elements.buttons.length > 0) {
      const firstButton = elements.buttons[0];
      firstButton.classList.add('active');
      selectedPlan = firstButton.dataset.planTitle;
      saveSelectedPlan(selectedPlan);
      updatePlanImage(firstButton.getAttribute('data-object-plan-url'));
    }

    // Update prices for the selected plan
    if (selectedPlan) {
      priceCalculator.updatePricesForPlan(selectedPlan, (items) => {
        ajaxService.updateItemPrices(items).catch(console.error);
      });
    }
  }

  function setConfirmedState() {
    if (planConfirmed) {
      elements.body.classList.add('plan-confirmed');
    }
  }

  function handlePlanSelection(button) {
    if (userDisabled) return;

    // Update button states
    elements.buttons.forEach(btn => btn.classList.remove('active'));
    button.classList.add('active');
    
    selectedPlan = button.dataset.planTitle;
    saveSelectedPlan(selectedPlan);

    // Update prices for new plan
    priceCalculator.updatePricesForPlan(selectedPlan, (items) => {
      ajaxService.updateItemPrices(items).catch(console.error);
    });

    // Update plan image
    const newImageUrl = button.getAttribute('data-object-plan-url');
    updatePlanImage(newImageUrl);
    
    // Update download link
    const planDownloadBtn = document.querySelector('[data-plan-open-btn]');
    if (planDownloadBtn) {
      planDownloadBtn.href = newImageUrl;
    }
  }

  function updatePlanImage(imageUrl) {
    elements.imgElements.forEach(imgElement => {
      imgElement.setAttribute('src', imageUrl);
    });
  }

  async function saveSelectedPlan(plan) {
    try {
      await ajaxService.saveSelectedPlan(plan);
    } catch (error) {
      console.error('Error saving plan:', error);
    }
  }

  async function confirmPlan() {
    try {
      const timestamp = new Date().toLocaleString();
      await ajaxService.confirmSelection('plan', timestamp);

      elements.confirmButton.classList.add('confirmed');
      elements.confirmButton.textContent = 'Planeering kinnitatud';
      elements.frontPlanButton.textContent = 'Planeering kinnitatud';
      elements.body.classList.add('plan-confirmed');

      notificationManager.showSuccessMessage('confirmed', 'plan', timestamp);

    } catch (error) {
      console.error('Error confirming plan:', error);
    }
  }

  async function resetPlanConfirmation() {
    try {
      await ajaxService.resetConfirmation('plan');

      elements.confirmButton.classList.remove('confirmed');
      elements.confirmButton.textContent = 'Kinnita planeering';
      elements.frontPlanButton.textContent = 'Planeeringut kinnitama';
      elements.body.classList.remove('plan-confirmed');

      notificationManager.showSuccessMessage('reset', 'plan');

    } catch (error) {
      console.error('Error resetting plan confirmation:', error);
    }
  }
}